function CustomizableAvatar({
  customClass,
  src,
  height,
  width,
  alt,
  avatarClass,
}) {
  return (
    <div className={customClass}>
      <img
        src={src}
        height={height}
        width={width}
        alt={alt}
        className={avatarClass}
      />
    </div>
  );
}

export default CustomizableAvatar;
